module.exports = __webpack_public_path__ + "static/media/comment3_2.98ed70fb.png";